<template>
    <div v-if="!dismissed" class="alert-message alert" :class="alertClasses" role="alert">
        <div v-if="message" v-html="message"></div>
        <slot v-else></slot>
        <button
            v-if="dismissible"
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="doDismiss"
        >
            <i class="fas fa-times" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
/* globals localStorage */
export default {
    name: 'AlertMessage',
    props: {
        message: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'info',
            validator: v => ['info', 'success', 'warning', 'danger'].indexOf(v) !== -1
        },
        dismissible: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
        },
    },
    data() {
        return {
            dismissed: false,
        };
    },
    mounted() {
        if (this.dismissible && this.name) {
            const value = JSON.parse(localStorage.getItem(`${this.name}_dismissed`));
            this.dismissed = value;
        }
    },
    computed: {
        alertClasses() {
            return {
                'alert-info': this.type === 'info',
                'alert-success': this.type === 'success',
                'alert-warning': this.type === 'warning',
                'alert-danger': this.type === 'danger',
                'alert-dismissible': this.dismissible,
            }
        }
    },
    methods: {
        doDismiss() {
            if (this.dismissible && this.name) {
                localStorage.setItem(`${this.name}_dismissed`, true);
            }
        },
    },
}
</script>
